import { CountryFormConfiguration } from "../constants";
import { Malaysia } from "./MY";

export const MalaysiaMS: CountryFormConfiguration = Malaysia("ms-MY");
